export default class EditController
{
	constructor($scope, $http, $location, $routeParams) {
		this.$scope = $scope;
		this.$http = $http;
		this.$location = $location;
		this.$scope.$parent.title = 'Modify record';

		this.success = false;

		this.id = $routeParams.id;
		this.attributes = {};

		this.get();
	}

	submit() {
		this.save();
	}

	get() {
		this.$http({
			method: 'GET',
			url: '/api/records/'+this.id
		}).then((response) => {
			let data = response.data.data;
			data.date_visited = new Date(data.date_visited);
			this.attributes = data;
		}, (response) => {
			alert('Unable to load record');
			this.$location.url('/records');
		});
	}

	save() {
		this.$http({
			method: 'PATCH',
			url: '/api/records/'+this.id,
			data: this.attributes
		}).then((response) => {
			this.success = true;
		}, (response) => {
			alert('Unable to update record');
		});
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/records/edit.controller.js
 **/